
import { Router, RouteConfigLoadStart, RouteConfigLoadEnd, RouterOutlet } from '@angular/router';

import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { ClientCommandsService } from '@services/ClientCommands.service';
import { ContextService } from './@core/services/Context.service';
import { PrimeNG } from 'primeng/config';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet, ConfirmDialogModule, ConfirmPopupModule]
})
export class AppComponent implements OnInit {
  options = signal({ className: 'p-confirm-popup-info' });
  title = 'zAppDevManager';

  constructor(
    protected readonly client: ClientCommandsService,
    protected readonly router: Router,
    protected readonly translateService: TranslateService,
    protected readonly contextService: ContextService,
    protected readonly titleService: Title,
    private config: PrimeNG,
  ) {
    this.titleService.setTitle(`Application loading... | ${this.title}`);
  }
  
  ngOnInit() {
    if (window.onbeforeunload == null) {
      window.onbeforeunload = (event: any) => {
        if (!window._context.isDirty) {
          return;
        }

        event.preventDefault();
        event.returnValue = this.translateService.instant('RES_SITE_Changesnotsaved');
        return event;
      }
    }

    this.client.onConfirmOptions()
      .subscribe((options => {
        this.options.set(options);
      }));

    this.contextService.context$.subscribe((context) => {
        const lang = context.currentLanguage.languageIetTag;
        this.translateService.use(lang);
        this.translate(lang);
    });

  }

  translate(lang: string) {
    this.translateService.get('primeng').subscribe(res => {
      this.config.setTranslation(res);
    });
  }

}